import styled from 'styled-components';
import {
  Tabs as MatTabs,
} from '@material-ui/core';
export const UiMatTab = styled(MatTabs)`
	display: block;
	margin: 1rem 0;
`;
